<template>
  <div class="w-full flex h-screen">
    <div class="w-full flex flex-col justify-center items-center p-4 bg-gray-300">
      <div>
        <img class="mx-auto w-auto" src="@/assets/img/logo_acceso.png">
      </div>
      <form method="post" class="w-full max-w-md bg-white p-4 sm:p-8 mt-6 rounded-lg shadow-lg space-y-4">
        <div>
          <label for="email" class="text-sm font-semibold tracking-wide text-primario">
            {{ $t('lang.fields.email') }}
          </label>
          <input
            id="email"
            :name="$t('lang.fields.email')"
            type="email"
            required
            autofocus
            v-model="credentials.userEmail"
            class="w-full form-input mt-1 shadow-sm"
            placeholder="email@dominio.com"
            aria-label="email@dominio.com"
          >
        </div>

        <div>
          <label for="password" class="text-sm font-semibold tracking-wide text-primario">
            {{ $t('lang.fields.password') }}
          </label>
          <input
            id="password"
            type="password"
            name="password"
            required
            placeholder="********"
            v-model="credentials.userPassword"
            class="w-full form-input mt-1 shadow-sm"
            :aria-label="$t('lang.fields.password')"
          >
        </div>

        <p v-if="showErrors" class="text-sm capitalize tracking-wide text-rojo font-semibold">
          {{ $t('lang.msg.invalidCredentials') }}
        </p>

        <button
          type="submit"
          @click.prevent="login"
          class="relative block w-full py-2 px-3 border border-transparent rounded-md bg-primario hover:bg-primario focus:bg-primario focus:outline-none focus:shadow-outline"
        >
          <span class="absolute left-0 inset-y pl-3">
            <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path
                d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                clip-rule="evenodd"
                fill-rule="evenodd"
              />
            </svg>
          </span>
          <span class="text-sm font-semibold text-gray-100 sm:leading-5 uppercase">
            {{ $t('lang.fields.signIn') }}
          </span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      showErrors: false,
      credentials: {
        userEmail: "",
        userPassword: ""
      }
    };
  },
  methods: {
    login() {
      this.$axios
        .post("api/Login/Login", this.credentials)
        .then((response) => {
          const token = response.data.token;
          this.$store.dispatch("auth/setToken", token, { root: true });
        })
        .catch(() => {
          this.showErrors = true;
        });
    }
  }
};
</script>